import React from "react";
const Tab = ({ text, className, tab, setTab }) => (
  <li className={`mx-2 ${className}`}>
    <button
      href="#"
      className={`text-black py-5 block  capitalize ${
        tab === text ? "font-bold border-yellow-400 border-b-4" : "font-normal"
      }`}
      type="button"
      onClick={() => setTab(text)}
    >
      {text}
    </button>
  </li>
);
export default function Nav({ tab, setTab }) {
  return (
    <ul className="bg-gray-100 flex px-20">
      {/* <Tab text="Case Updates" setTab={setTab} tab={tab} /> */}
      <Tab text="Add Source" setTab={setTab} tab={tab} className="ml-0" />
    </ul>
  );
}
